module.exports = __webpack_public_path__ + "img/pen.70bf2131.svg";